import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Stepper from '@material-ui/core/Stepper';
import React from 'react';
import { useStyles } from '../TrackPage';

interface TrackStepperProps {
  steps: string[];
  stepLabels: Record<string, string>;
  activeStep: string;
}

export const TrackStepper: React.FC<TrackStepperProps> = ({
  steps,
  stepLabels,
  activeStep,
}) => {
  const styles = useStyles();
  const activeStepIndex = steps.indexOf(activeStep);

  return (
    <Stepper
      activeStep={activeStepIndex}
      alternativeLabel
      className={styles.stepper}
    >
      {steps.map((label, i) => (
        <Step
          key={label}
          completed={
            i < activeStepIndex ||
            (activeStepIndex === steps.length - 1 && i === activeStepIndex)
          }
        >
          <StepLabel>{stepLabels[label]}</StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};
